import {getRolesTypes} from "../../index";

export const isSuperAdmin = (user) => {
    var roles = getRolesTypes();
    if (user.roles) {
        var roleID = user.roles[0];
        var val = '';
        roles.forEach(role => {
            if (role.id === roleID) {
                val = role.name;
            }
        });
        return val === 'SuperAdmin';

    } else {
        return false;
    }
}